export default "__VITE_ASSET__CnbJpdFS__"